module.exports = __webpack_public_path__ + "img/closeAttach.97c53ebe.svg";